<template>
  <div id="dashboard">
    <page-title></page-title>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="dashboard-block">
            <div class="table-header devices-search">
              <p class="sub-title">常用设备列表</p>
              <div class="input-group input-group-sm ">
                <input type="text" @keyup.enter="loadDevices" v-model="search.devices.q" class="form-control"
                       placeholder="名称或设备号">
                <div @click="loadDevices" class="input-group-append">
                  <i class="iconfont icon-msnui-find-bold"></i>
                </div>
              </div>
            </div>
            <div v-if="loading.devices">
              <loading></loading>

            </div>
            <div v-else-if="!devices.length">
              暂无数据
            </div>
            <div class="table-responsive" v-else>
              <table class="table  table-leemma">
                <thead>
                <tr>
                  <th>DTU号</th>
                  <th>名称</th>
                  <th>所属公司</th>
                  <th>消息成功率</th>
                  <th>设备掉线率</th>
                  <th>状态</th>
                  <th v-if="account.info.role!=='employee'">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(device,index) in devices">
                  <td><a target="_blank" :href="customerUrl+device.id">{{device.device_sn}}</a></td>
                  <td><a target="_blank" :href="customerUrl+device.id">{{device.name}}</a></td>
                  <td>LEEMMA</td>
                  <td>{{(device.success_p*100).toFixed(1)}}%</td>
                  <td>{{(device.offline_p*100).toFixed(1)}}%</td>
                  <td :data-toggle="device.status==='在线'?'':'tooltip'" data-placement="left" :title="device.status_dec"
                      :class="{'status-success':device.status==='在线','status-danger':device.status!=='在线'}">
                    {{device.status?device.status:'异常'}}
                  </td>
                  <td v-if="account.info.role!=='employee'">
                    <button @click="openModal('IP_PORT',index)" class="btn btn-success btn-sm">端口设置</button>
                    <button @click="openModal('CODE',index)" class="btn btn-primary btn-sm">代码设置</button>
                  </td>
                </tr>
                </tbody>
              </table>
              <page :page-size="search.devices.page_size" :count="search.devices.count"
                    :page-no="search.devices.page_no" @click="paging"></page>

            </div>

          </div>
        </div>

      </div>
      <div class="row overview-data">
        <div class="col-lg-3">
          <div class="overview-item dashboard-block">
            <router-link to="devices">
              <img class="icon-img" src="../assets/img/online-devices.png" alt="在线设备数量">
            </router-link>
            <div>
              <p class="overview-num">{{statistics.devices.online_devices}}</p>
              <p>在线设备数量</p>
            </div>
          </div>

        </div>
        <div class="col-lg-3 ">
          <div class="overview-item dashboard-block">
            <router-link to="devices">
              <img class="icon-img" src="../assets/img/devices.png" alt="总设备数量">
            </router-link>
            <div>
              <p class="overview-num">{{statistics.devices.total}}</p>
              <p>总设备数量</p>
            </div>
          </div>


        </div>
        <div class="col-lg-3 ">
          <div class="overview-item dashboard-block">
            <router-link to="customers">
              <img class="icon-img" src="../assets/img/customers.png" alt="总客户数量">
            </router-link>
            <div>
              <p class="overview-num">{{statistics.customers.total}}</p>
              <p>总客户数量</p>
            </div>
          </div>

        </div>
        <div class="col-lg-3">
          <div class="overview-item dashboard-block">
            <router-link to="devices">
              <img class="icon-img" src="../assets/img/login-device.png" alt="登陆设备数量">
            </router-link>
            <div>
              <p class="overview-num">{{statistics.devices.connected_devices}}</p>
              <p>激活设备数量</p>
            </div>
          </div>

        </div>

      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="dashboard-block">
            <p class="sub-title">消息成功率</p>
            <div class="msg-block pv-block">
              <ring blod="10" :pv="(info.average.ave_success_percent*100).toFixed(0)" color="#03A9F5" width="110">
                <div class="ring-icon">
                  <i class="iconfont icon-duigou"></i>
                </div>
                <span v-show="info.average.ave_success_percent" class="pv">{{(info.average.ave_success_percent*100).toFixed(0)}}%</span>
              </ring>
              <div class="pv-info">
                <div>
                  <p class="pv-s">发送成功</p>
                  <p>{{info.average.success_times?info.average.success_times:0}}</p>
                </div>
                <div class="pv-split">

                </div>
                <div>
                  <p class="pv-f">发送失败</p>
                  <p>{{info.average.failed_times?info.average.failed_times:0}}</p>
                </div>

              </div>

            </div>

          </div>

        </div>
        <div class="col-lg-8">
          <div class="dashboard-block">
            <p class="sub-title">在线统计</p>
            <div class="online-block row">
              <div class="title col-3 ">
                <p>在线客户数量：{{info.online[0]?info.online[info.online.length-1].customers:0}}</p>
                <p>在线设备数量：{{info.online[0]?info.online[info.online.length-1].devices:0}}</p>
              </div>
              <div class="online-charts col-9" ref="online">

              </div>
            </div>
          </div>
        </div>


      </div>

      <div class="row">
        <div class="col-lg-4">
          <div class="dashboard-block">
            <p class="sub-title">设备掉线率</p>
            <div class="device-pv-block pv-block">
              <ring blod="10" :pv="(info.average.ave_offline_percent*100).toFixed(0)*1" width="110" color="#dc3545">
                <div class="ring-icon">
                  <i class="iconfont icon-gantanhao"></i>
                </div>
                <span v-show="info.average.ave_offline_percent" class="pv">{{(info.average.ave_offline_percent*100).toFixed(0)}}%</span>
              </ring>
              <div class="pv-info">
                <div>
                  <p class="pv-s">连接次数</p>
                  <p>{{info.average.connected_times?info.average.connected_times:0}}</p>
                </div>
                <div class="pv-split">
                </div>
                <div>
                  <p class="pv-f">掉线次数</p>
                  <p>{{info.average.offline_times?info.average.offline_times:0}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="dashboard-block">
            <p class="sub-title">增长统计</p>
            <div class="growth-charts" ref="growth">

            </div>
          </div>

        </div>
        <div class="col-lg-8">
          <div class="dashboard-block">
            <p class="sub-title">设备地图</p>
            <div class="map-charts" ref="map">

            </div>
          </div>
        </div>

      </div>


    </div>


    <!-- Modal -->
    <div class="modal fade" ref="modal" id="exampleModal" tabindex="-1" role="dialog"
         aria-labelledby="exampleModalLabel"
         aria-hidden="true">
      <div class="modal-dialog  modal-lg" role="document">
        <div class="modal-content  bg-dark">

          <div class="modal-body">
            <div v-if="modal.type==='IP_PORT'">
              <div class="modal-item">
                <div class="modal-item-title">
                  <h5>IP端口设置
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </h5>
                </div>
                <div v-if="loading.ipPort" class="item-body">
                  <loading></loading>
                </div>
                <div v-else class="item-body">
                  <div class="device-ipport">
                    <span>当前IP：{{modal.ipPort.ip?modal.ipPort.ip:'无法识别'}}</span>
                    <span>当前端口号：{{modal.ipPort.port?modal.ipPort.port:'无法识别'}}</span>
                  </div>
                  <form>
                    <div class="form-group">
                      <label>修改当前IP</label>
                      <input v-model="modal.ipPort.ip" type="text" class="form-control" placeholder="请输入ip">
                    </div>
                    <div class="form-group">
                      <label>修改当前端口号</label>
                      <input v-model.number="modal.ipPort.port" type="text" class="form-control" placeholder="请输入端口号">
                    </div>

                  </form>
                  <div class="item-button-group">
                    <button @click="setDeviceIpPort" type="button" class="btn btn-sm btn-success">保存</button>
                  </div>
                </div>
              </div>
              <div class="modal-item">
                <div class="modal-item-title">
                  <h5>IOT服务超时时间设置</h5>
                </div>
                <div v-if="loading.timeout" class="item-body">
                  <loading></loading>
                </div>
                <div v-else class="item-body">
                  <div class="device-ipport">
                    <span>当前IOT服务超时时间：{{modal.timeout?modal.timeout:"无法识别"}}</span>

                  </div>
                  <form>
                    <div class="form-group">
                      <label>修改当前IOT服务超时时间</label>
                      <input v-model="modal.timeout" type="text" class="form-control" placeholder="请输入IOT超时时间（秒）">
                    </div>

                  </form>
                  <div class="item-button-group">
                    <button @click="setDeviceTimeout" type="button" class="btn btn-sm btn-success">保存</button>
                  </div>
                </div>
              </div>
              <div class="modal-item">
                <div class="modal-item-title">
                  <h5>功能按钮</h5>
                </div>
                <div v-if="loading.reset" class="item-body">
                  <loading></loading>
                </div>
                <div v-else class="item-body">
                  <div class="setting-group">
                    <div @click="setDeviceReset" class="device-setting-button">
                      <div>
                        重新连接
                      </div>
                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div v-else-if="modal.type==='CODE'">
              <div class="modal-item">
                <div class="modal-item-title">
                  <h5>设备代码版本设置
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </h5>
                </div>
                <div v-if="loading.codeVersion" class="item-body">
                  <loading></loading>
                </div>
                <div v-else class="item-body ">
                  <div class="form-group input-group-sm row">
                    <label class="col-md-2 col-form-label">选择窑号</label>
                    <select v-model="modal.sys_alias" class="form-control col-md-2">
                      <option v-for="n in intAlias" :value="n">{{n}}号窑</option>
                    </select>
                  </div>
                  <div>
                    <p>当前设备代码版本：{{modal.code.nowVersion?modal.code.nowVersion:'无法识别'}}</p>
                    <p>备份代码版本：{{modal.code.bakVersion?modal.code.bakVersion:'无法识别'}}
                      <button type="button" @click="reSetCodeVersion" class="btn btn-primary btn-sm">还原至备份版本</button>
                    </p>
                  </div>

                  <div class="code-list">
                    <h6>版本列表</h6>
                    <input type="file" multiple="multiple" @change="uploadFile">
                    <div style="width:300px" class="input-group m-3">
                      <div class="custom-file">
                        <input @change="uploadFile" type="file" class="custom-file-input" id="inputGroupFile01">
                        <label class="custom-file-label" for="inputGroupFile01">上传文件</label>
                      </div>
                    </div>
                    <table class="table">
                      <tr>
                        <th>名称</th>
                        <th>操作</th>
                      </tr>
                      <tr v-for="(item,key) in codeList">
                        <td>{{key}}</td>
                        <td>
                          <button @click="setCodeVersion(item)" class="btn btn-primary btn-sm" type="button">应用</button>
                          <button class="btn btn-outline-danger btn-sm" @click="deleteCodeFile(item)" type="button">删除
                          </button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="modal-footer">-->
            <!--<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>-->
          <!--</div>-->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import pageTitle from "@/components/pageTitle";
  import ring from '@/components/rings'
  import Moment from 'moment'
  import echarts from 'echarts'
  import DISTRICT from '@/assets/lib/district.js'
  import page from '@/components/pagination'

  import {mapState} from 'vuex'

  require('echarts/map/js/china')

  export default {
    name: "dashboard",
    components: {
      pageTitle,
      ring,
      page
    },
    data() {
      return {
        customerUrl: '',
        role:'',
        search: {
          devices: {
            page_no: 1,
            page_size: 15,
            count: '',
            q: ''
          }
        },
        devices: [],
        statistics: {
          devices: {},
          customers: {}
        },
        info: {
          average: {},
          growth: {},
          online: {}
        },
        modal: {
          type: 'CODE',
          code: {},
          ipPort: {},
          timeout: '',
          device: {},
          sys_alias: 1
        },
        codeList: [],
        codeSearch: {},
        loading: {
          devices: false,
          ipPort: false,
          timeout: false,
          codeList: false,
          reset: false,
          codeVersion: false
        },
        signature: {}

      }
    },
    computed: {
      ...mapState({
        account: state => state.account,
      }),
      intAlias() {
        return this.modal.device.alias_m ? (this.modal.device.alias_m * 1) : 1
      }
    },
    created() {
      this.loadStatistics();
      this.loadStatisticsInfo();
      this.loadDevices();
    },
    mounted() {
      this.customerUrl = this.$config.leemmaCustomer + '/login?user_token=' + this.account.info.auth_token + '&device_id='
    },
    methods: {

      // 静态统计
      loadStatistics() {
        let url = 'statistics',
          params = {
            auth_token: 'default'
          };
        this.$http.get(url, {params}).then(data => {
          if (data.status_code === 'SUCCEEDED') {
            this.statistics = data.payload
          } else {
            console.error('静态统计获取失败')
          }
        })
      },
      //动态统计
      loadStatisticsInfo() {
        let url = '/statistics/info',
          params = {
            auth_token: 'default',
            begin: Moment().subtract('1', 'hour').format('YYYY-MM-DD'),
            end: Moment().format('YYYY-MM-DD')
          };
        this.$http.get(url, {params}).then(data => {
          if (data.status_code === 'SUCCEEDED') {
            this.info = data.payload
            this.initOnlineCharts();
            this.initMapCharts();
            this.initGrowthChart();

          } else {
            console.error('动态统计获取失败')
          }
        })
      },
      paging(no) {
        this.search.page_no = no;
        this.loadDevices()
      },
      loadDevices() {
        this.loading.devices = true;
        let url = 'devices',
          params = {
            auth_token: 'default',
            is_latest: true,
            q: this.search.devices.q

          };
        if (params.q) {
          params.is_latest = false
        }
        this.$http.get(url, {params}).then(data => {
          this.loading.devices = false;
          if (data.status_code === 'SUCCEEDED') {
            this.devices = data.payload
            this.$nextTick(() => {
              $(function () {
                $('[data-toggle="tooltip"]').tooltip()
              })
            })
          } else {
            console.error('设备列表获取失败')
          }
        })
      },
      ChartsDataFn(list) {
        let customers = [],
          devices = [],
          xData = [];
        list.forEach(item => {
          // let timestamp = Moment(item.timestamp).format('HH:mm') ;
          xData.push(item.timestamp)
          devices.push(item.devices)
          customers.push(item.customers)
        })
        return {
          xData,
          devices,
          customers
        }
      },
      initOnlineCharts() {
        let chartsData = this.ChartsDataFn(this.info.online),
          myChart = echarts.init(this.$refs.online),
          option = {
            title: {
              show: false
            },
            color: ['#1DE9B6', '#03A9F5'],
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              top: '3%',
              containLabel: true
            },
            tooltip: {
              show: true,
              trigger: 'axis'
            },
            xAxis: [{
              show: true,
              data: chartsData.xData,
              axisLine: {
                show: false,
                lineStyle: {color: '#ccc'}
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                formatter: function (value, index) {
                  return Moment(value).format('HH:mm');
                }
              }
            },],
            yAxis: [{
              show: false,
              inverse: false,
            },],
            series: [{
              name: '在线设备数量',
              type: 'line',
              areaStyle: {
                normal: {
                  color: '#27b194',
                  opacity: 0
                }
              },
              lineStyle: {
                normal: {
                  color: '#27b194'
                }
              },
              itemStyle: {
                normal: {
                  opacity: 1
                }
              },
              data: chartsData.devices
            }, {
              name: '在线客户数量',
              type: 'line',
              data: chartsData.customers
            }]
          };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);

      },


      initMapCharts() {
        let info = this.info.distribution, data = [];
        info.forEach(item => {
          data.push({
            name: DISTRICT[item.province],
            value: item.num
          })
        })
        let geoCoordMap = {
          '新疆维吾尔自治区': [87.68, 43.77],
          '甘肃省': [103.73, 36.03],
          '青海省': [101.74, 36.56],
          '西藏自治区': [91.11, 29.97],
          '宁夏回族自治区': [106.27, 38.47],
          '内蒙古自治区': [111.65, 40.82],
          '海南省': [110.35, 20.02],
          "上海市": [121.48, 31.22],
          "安徽省": [117.27, 31.86],
          "江苏省": [118.78, 32.04],
          "浙江省": [120.19, 30.26],
          "广东省": [113.23, 23.16],
          "福建省": [119.3, 26.08],
          "广西省": [108.33, 22.84],
          "河南省": [113.65, 34.76],
          "湖北省": [114.31, 30.52],
          "湖南省": [113, 28.21],
          "江西省": [115.89, 28.68],
          "北京市": [116.46, 39.92],
          "吉林省": [125.35, 43.88],
          "大连市": [121.62, 38.92],
          "辽宁省": [123.38, 41.8],
          "黑龙江省": [126.63, 45.75],
          "天津市": [117.2, 39.13],
          "山东省": [117, 36.65],
          "青岛市": [120.33, 36.07],
          "山西省": [112.53, 37.87],
          "河北省": [114.48, 38.03],
          "陕西省": [108.95, 34.27],
          "四川省": [104.06, 30.67],
          "重庆市": [106.54, 29.59],
          "云南省": [102.73, 25.04],
        };
        let convertData = function (data) {
          let res = [];
          for (let i = 0; i < data.length; i++) {
            let geoCoord = geoCoordMap[data[i].name];
            if (geoCoord) {
              res.push({
                name: data[i].name,
                value: geoCoord.concat(data[i].value)
              });
            }
          }
          return res;
        };
        let option = {
          title: {},
          backgroundColor: '27B194',
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              return params.name + ' : ' + params.value[2];
            }
          },
          legend: {
            orient: 'vertical',
            data: '设备数量',
            textStyle: {
              color: '#fff'
            }
          },
          geo: {
            map: 'china',
            label: {
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#27B194',
                borderColor: '#27B194'
              },
              emphasis: {
                areaColor: '#27B194'
              }
            }
          },
          series: [
            {
              name: '设备数量',
              type: 'effectScatter',
              coordinateSystem: 'geo',
              data: convertData(data),
              symbol: 'circle',//'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'
              symbolSize: 12,
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              rippleEffect: {
                brushType: 'stroke'
              },
              itemStyle: {
                emphasis: {
                  borderColor: '#fff',
                  borderWidth: 1
                }
              }
            }
          ]
        };
        let mapChart = echarts.init(this.$refs.map);
        mapChart.setOption(option);
      },
      initGrowthChart() {
        let _this = this,
          growthChart = echarts.init(this.$refs.growth),
          chartsData = this.ChartsDataFn(this.info.growth),
          option;
        option = {
          title: {
            show: false
          },
          color: ['#03A9F5','#1DE9B6', ],
          tooltip: {
            trigger: 'axis',
          },
          legend: {
            data: ['客户', '设备'],
            show: false
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              show: true,
              type: 'category',
              boundaryGap: false,

              axisLine: {
                show: false
              },
              axisLabel: {
                color: '#fff',
                formatter: function (value, index) {
                  return Moment(value).format('MM-DD');
                }
              },

              data: chartsData.xData
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitNumber: 2,
              axisLine: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisLabel: {
                color: '#fff',
              }

            }
          ],
          series: [
            {
              name: '客户',
              type: 'line',
              lineStyle: {
                normal: {
                  // color: '#27b194'
                }
              },
              itemStyle: {
                normal: {
                  opacity: 0
                }
              },
              smooth: true,
              data: chartsData.customers
            },
            {
              name: '设备',
              type: 'line',
              lineStyle: {
                normal: {
                  // color: '#03a9f5'
                }
              },
              itemStyle: {
                normal: {
                  opacity: 0
                }
              },
              smooth: true,
              data: chartsData.devices
            },

          ]
        };

        growthChart.setOption(option);

      },
      openModal(type, index) {
        this.modal.type = type;
        this.modal.sys_alias = "1";
        let device = this.modal.device = this.devices[index];
        $(this.$refs.modal).modal('show');
        if (type === 'IP_PORT') {
          this.loadDeviceIpPort(device);
          this.loadDeviceTimeout(device);
        } else if (type === 'CODE') {
          debugger
            this.getSignature();
          this.loadCodeList();
          this.loadDeviceCodeVersion(device)

        }

      },
      loadDeviceIpPort(device) {
        this.loading.ipPort = true;
        let url = `devices/${device.id}/ip_port`,
          params = {
            auth_token: 'default'
          };
        this.$http.get(url, {params}).then(data => {
          this.loading.ipPort = false;
          if (data.status_code === 'SUCCEEDED') {
            this.modal.ipPort = JSON.parse(data.payload.data)
          } else {
            console.error('获取IP_PORT失败')
          }
        })

      },
      setDeviceIpPort() {
        if (confirm("确定修改IP端口号？")) {
          let device = this.modal.device,
            url = `devices/${device.id}/ip_port`,
            params = {
              auth_token: 'default',
              payload: JSON.stringify(this.modal.ipPort)
            };
          this.loading.ipPort = true;
          this.$http.post(url, params).then(data => {
            this.loading.ipPort = false;
            if (data.status_code === 'SUCCEEDED') {
              this.$message({
                type: 'success',
                message: '操作成功'
              })
            } else {
              this.loadDeviceIpPort(device);
              this.$message({
                type: 'error',
                message: data.error,
              })
            }
          })
        }
      },
      loadDeviceTimeout(device) {
        this.loading.timeout = true;
        let url = `devices/${device.id}/iot_timeout`,
          params = {
            auth_token: 'default'
          };
        this.$http.get(url, {params}).then(data => {
          this.loading.timeout = false;
          if (data.status_code === 'SUCCEEDED') {
            this.modal.timeout = data.payload.timeout
          } else {
            console.error('获取timeout失败')
          }
        })

      },
      setDeviceTimeout() {
        let timeout = this.modal.timeout;
        if (timeout < 10 || timeout > 35) {
          this.$message.error(`操作失败,IOT超时时间必须大于10秒且小于35秒`)
          return false
        }
        if (confirm("确定修改IOT超时时间？")) {
          this.loading.timeout = true;
          let device = this.modal.device,
            url = `devices/${device.id}/iot_timeout`,
            params = {
              auth_token: 'default',
              payload: JSON.stringify({timeout: this.modal.timeout * 1})
            };
          this.$http.post(url, params).then(data => {
            this.loading.timeout = false;
            if (data.status_code === 'SUCCEEDED') {
              this.$message({
                type: 'success',
                message: '操作成功'
              })
            } else {
              this.$message.error(`操作失败,${data.msg}`);
              this.loadDeviceTimeout(device)
            }
          })
        }
      },
      setDeviceReset() {
        this.loading.reset = true;
        let device = this.modal.device,
          url = `devices/${device.id}/reset`,
          params = {
            auth_token: 'default'
          };
        this.$http.post(url, params).then(data => {
          this.loading.reset = false;
          if (data.status_code === 'SUCCEEDED') {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
          } else {
            this.$message({
              type: 'error',
              message: '操作失败,' + data.msg
            })
          }
        })

      },
      loadDeviceCodeVersion(device) {
        this.loading.codeVersion = true;
        let url = `devices/${device.id}/version`,
          params = {
            auth_token: 'default',
            sys_alias: this.modal.sys_alias
          };
        this.$http.get(url, {params}).then(data => {
          this.loading.codeVersion = false;
          if (data.status_code === 'SUCCEEDED') {
            this.modal.code = JSON.parse(data.payload.data)
          } else {
            console.error('获取版本信息失败')
          }
        })

      },
      loadCodeList() {
        let url = `device_providers/${this.account.info.company_id}/objects`,
          params = {
            auth_token: 'default',
            prefix: this.account.info.company_id,
            _: Date.now()
          };
        this.$http.get(url, {params}).then(data => {
          if (data.status_code === 'SUCCEEDED') {
            this.codeList = this.dealCodeList(data.payload.data);

          } else {
            console.error('获取版本列表失败')
          }
        })
      },
      dealCodeList(list) {
        let json = {}, dirName;
        list.forEach((v, i) => {
          dirName = v.name.split('/')[1];
          if (json[dirName]) {
            json[dirName].push(v)
          } else {
            json[dirName] = [v]
          }
        });
        return json
      },
      //aliyun oss signature
      getSignature() {
        let ossSignature = '';
        //JSON.parse(localStorage.getItem('ossSignature'))
        if (ossSignature) {
          this.$store.dispatch('updataOssSignature', ossSignature);
          this.signature = this.account.ossSignature;
        } else {
          let url = 'signature',
            params = {auth_token: 'default', company_id: 'code--leemma'};
          this.$http.get(url, {params}).then(data => {
            if (data.status_code === 'SUCCEEDED') {
              this.signature = data.payload;
              this.$store.dispatch('updataOssSignature', data.payload)
            } else {
              console.error('获取oss签名失败,' + data.msg)
            }
          });
        }


      },
      uploadFile(e) {
        let formdata = new FormData(),
          signature = this.signature,
          file = e.target.files[0],
          jData = {
            OSSAccessKeyId: signature.accessid,
            policy: signature.policy,
            signature: signature.signature,
            success_action_status: 200,
            key: file.name,
          };
        console.log(jData)

        for (let field_name in jData) {
          formdata.append(field_name, jData[field_name]);
        }
        formdata.append('file', file);
        //console.log(formdata);
        let oReq = new XMLHttpRequest(), _this = this;
        //上传结果
        oReq.onreadystatechange = function (e) {
          if (oReq.readyState == 4) {
            if (oReq.status == 200) {//这里如果成功返回的是 success_action_status设置的值
              _this.loadCodeList()
            }
          }
        };
        oReq.open("POST", signature.host);
        oReq.send(formdata);
      },
      setCodeVersion(item) {
        this.loading.codeVersion = true;
        let device = this.modal.device,
          url = `devices/${device.id}/updatecode`,
          params, payload;
        payload = {
          devNo: this.modal.sys_alias * 1,
          fileAddrs: [item[0].url, item[1].url, item[2].url],
        };
        params = {
          auth_token: 'default',
          payload: JSON.stringify(payload)
        };
        this.$http.post(url, params).then(data => {
          this.loading.codeVersion = false;
          if (data.status === 'SUCCEEDED') {
            this.$message.success('操作成功')
          } else {
            this.$message.error('操作失败')
          }
        })
      },
      reSetCodeVersion(item) {
        this.loading.codeVersion = true;
        let device = this.modal.device,
          url = `devices/${device.id}/version`,
          params, payload;

        params = {
          auth_token: 'default',
          sys_alias: this.modal.sys_alias * 1,
        };
        this.$http.post(url, params).then(data => {
          this.loading.codeVersion = false;
          if (data.status === 'SUCCEEDED') {
            this.$message.success('操作成功')
          } else {
            this.$message.error('操作失败')
          }
        })

      },
      deleteCodeFile(item) {
        let url = `device_providers/${this.account.info.company_id}/objects`,
          deleteOssFile = (fileName) => {
            let params = {
              auth_token: 'default',
              object_name: fileName
            }
            return this.$http.delete(url, {params})
          };
        Promise.all([deleteOssFile(item[0].name), deleteOssFile(item[1].name), deleteOssFile(item[2].name)]).then(data => {
          this.$message.success('操作成功')
          this.loadCodeList();
        }).catch(err => {
          this.$message.error('操作失败')
        })

      }


    }
  };
</script>

<style lang="scss" scoped>
  .dashboard-block {
    background: $dark;
    margin-bottom: pxTorem(10px);
    padding: pxTorem(15px) pxTorem(15px);
    img {
      max-width: 100%;
    }

  }

  .sub-title {
    font-size: pxTorem(20px);
  }

  .overview-data {
    .overview-item {
      display: flex;
      justify-content: space-around;
      font-size: pxTorem(20px);
      text-align: center;

      .overview-num {
        font-size: 2rem;
        margin: 0;
      }
      .icon-img {
        /*width: pxTorem(80px);*/
        height: pxTorem(80px);
      }
    }
  }

  .devices-search {
    display: flex;
    justify-content: space-between;
    .input-group {
      width: 150px;
      align-items: center;
      border: 1px solid #1F2037;
      border-radius: 4px;
      .form-control {
        border: none;
      }
      .input-group-append {
        padding: 0 10px;
        cursor: pointer;
      }
    }
    .sub-title {
      margin-bottom: 0;
    }
  ;
  }

  .ring-icon {
    position: absolute;
    left: 20px;
    top: 12px;
    color: $primary;
    .iconfont {
      font-size: 2rem;
    }
  ;

  }

  .device-pv-block .ring-icon {
    color: $danger;
  }

  .pv {
    position: absolute;
    right: -80px;
    top: 14px;
    font-size: 2rem;
  }

  .pv-info {
    display: flex;
    justify-content: center;
    text-align: center;
    padding-top: 2rem;
    .pv-s {
      color: $success;
    }
    .pv-f {
      color: $danger
    }
    .pv-split {
      border-right: 1px solid #fff;
      margin: 0 2rem;
    }
  }

  .online-block {
    display: flex;
    .online-charts {
      height: 202px;
    }
    .title {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      flex-direction: column;
    }
  }

  .growth-charts {
    height: 200px;
  }

  .map-charts {
    height: 488px;
  }

  .modal-item {
    border-bottom: 1px solid #fff;
    padding: pxTorem(10px) pxTorem(10px) pxTorem(30px);
    margin-bottom: 15px;
    .modal-item-title {
      margin-bottom: pxTorem(25px);
      h5 {
        font-size: 1.1rem;
        font-weight: 600;

      }
    }
    .device-ipport {
      margin-bottom: pxTorem(25px);
    }
    .setting-group {
      display: flex;
      justify-content: center;
      .device-setting-button {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background: rgba(35, 120, 220, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          width: 80%;
          height: 80%;
          border-radius: 50%;
          background: rgba(35, 120, 220, 1);
          text-align: center;
          line-height: 80px;
          cursor: pointer;
        }
      }

    }
  }

  .item-button-group {
    padding-top: 10px;
    text-align: right;
    .btn {
      width: 100px;
    }
  }

  .modal-item:last-child {
    border-bottom: none
  }
</style>



// WEBPACK FOOTER //
// src/view/dashboard.vue